<template>
    <div>
        <navbar></navbar>
        <div class="__whitespace"></div>
        <div class="container">
            <div class="row __flexsmail">
                <div class="col-lg-6 col-md-6 col-sm-6 __mobidown">
                    <!-- <p class="__portp">Lagos city marathon</p> -->
                    <p class="__portp">{{projects[selectedProject].name}}</p>
                    <!-- <p class="__portp1">Website redesign</p> -->
                    <p class="__portp1">{{projects[selectedProject].tasks}}</p>
                    <!-- <p class="__portp2">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p> -->
                    <p class="__portp2">{{projects[selectedProject].scope}}</p>
                    <!-- <p class="__sthringlink"><router-link to="/">Visit website <img src="../assets/img/right-arrow-top.svg"> </router-link></p> -->
                    <p class="__sthringlink"><a :href="projects[selectedProject].siteUrl" target="_blank" >Visit website <img src="../assets/img/right-arrow-top.svg"></a></p>
                    
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 __mobiup">
                    <img :src="projects[selectedProject].bigImage" class="__climg">
                    <!-- <img src="../assets/img/showcasejb.png" class="__climg"> -->
                </div>
            </div>

            <div class="__whitespace"></div>
            <!-- <p class="__portlor">Lorem ipsum</p> -->
            <p class="__portlor">Scope & Product Concept</p>
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">

                    <img :src="projects[selectedProject].otherImages[0]" class="__lorimg">
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                    <img :src="projects[selectedProject].otherImages[1]" class="img-responsive __lorimg">
                </div>
                <!-- <div class="col-lg-4 col-md-4 col-sm-4">
                    <img :src="projects[selectedProject].otherImages[4]" class="img-responsive __lorimg">
                </div> -->
            </div>
            <!-- <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8">
                    <img :src="projects[selectedProject].otherImages[6]" class="__lorimg">
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <img :src="projects[selectedProject].otherImages[0]" class="img-responsive __lorimg">
                </div>
            </div> -->
            <br><br>

            <!-- <div class="__whitespace"></div> -->
            <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-10">
                    <!-- <p class="__portlord">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> -->
                    <p class="__portlord">{{projects[selectedProject].scope}}</p>

                    <!-- <p class="__portlord">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p> -->
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>
            </div>

            <div class="__whitespace"></div>
            <!-- <p class="__portlor">Lorem ipsum</p> -->
            <p class="__portlor">Design & Web Development</p>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <img :src="projects[selectedProject].otherImages[2]" class="img-responsive __lorimg">
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <img :src="projects[selectedProject].otherImages[3]" class="__lorimg">
                </div>
            </div>
            
            <!-- <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <img :src="projects[selectedProject].bigImage" class="__lorimg">
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <img :src="projects[selectedProject].otherImages[1]" class="img-responsive __lorimg">
                </div>
            </div> -->
            <br><br>

            <!-- <div class="__whitespace"></div> -->
            <!-- <p class="__portlor">Lorem ipsum</p> -->
            <!-- <p class="__portlor">Project Management & Launching</p> -->
            <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-10">
                    <!-- <p class="__portlord">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p> -->
                    <p class="__portlord">{{projects[selectedProject].design}}</p>
                    

                    <!-- <p class="__portlord">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat</p> -->
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>
            </div><br><br>

            <!-- <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <img :src="projects[selectedProject].otherImages[4]" class="__lorimg">
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <img :src="projects[selectedProject].otherImages[7]" class="img-responsive __lorimg">
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <img :src="projects[selectedProject].otherImages[0]" class="__lorimg">
                </div>
            </div> -->

            <!-- <div class="__whitespace"></div>
            <p class="__portlor">Project Management & Launching</p>
            <div class="row">
                <div class="col-lg-10 col-md-10 col-sm-10">
                    <p class="__portlord">{{projects[selectedProject].projectManagement}}</p>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2"></div>
            </div> -->

            <div class="__whitespace"></div>
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4 ">
                    <p
                    class="__pre"
                        @click="go(-1)"
                        :disabled="this.selectedProject == 0"
                        ><span><i class="fas fa-caret-left"></i></span>&nbsp;Previous  Project
                    </p>
                    <!-- <router-link to="/" class="__pre"><span><i class="fas fa-arrow-left"></i></span>&nbsp;Previous  Project</router-link> -->
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 text-center">
                    <a :href="projects[selectedProject].siteUrl" terget="blank" class="btn __viewsite">View Site</a>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <p
                    :disabled="this.selectedProject == projects.length - 1"
                        class="__nxt"
                        @click="go(1)"
                        >Next  Project&nbsp;<span><i class="fas fa-caret-right"></i></span>
                    </p>
                    <!-- <router-link to="/" class="__nxt">Next  Project&nbsp;<span><i class="fas fa-arrow-right"></i></span></router-link> -->
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4 ">
                    <p class="__pre"><router-link to="/"><span><i class="fas fa-caret-left"></i></span>&nbsp;Previous  Project</router-link></p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center">
                    <a href="" terget="blank" class="btn __viewsite">View Site</a>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4">
                    <p class="__nxt"><router-link to="/">Next  Project&nbsp;<span><i class="fas fa-caret-right"></i></span></router-link></p>
                </div>
            </div> -->
        </div>
        <div class="__stbg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5 col-md-5 col-sm-5">
                        <p class="__wwd">Start a project with us</p>
                        <p class="__fbuild">We know how much your idea means to you. What we do is take those ideas and convert them to world-class software products.</p>
                        <router-link to="/build" class="btn __startp">Lets do this</router-link>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-7"></div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import navbar from '../components/navbar';
import projects from '../assets/js/projects.json'

export default {
    components: { navbar },
    name: 'portfolio',
    data(){
        return{
            projects: [],
            selectedProject: 0,
            found: ''
        }
    },
    mounted(){
        this.projects = projects
        this.selectedProject = this.$store.state.found
    },
    methods:{
        go(index){
            this.selectedProject += index;

        }
    }
    
}
</script>

<style scoped>
@import '../assets/css/portfolio';
</style>


// WEBPACK FOOTER //
// src/components/portfolio.vue